import { useEffect, DependencyList } from 'react';

export const useScript = (
  content: string,
  id: string,
  dependents: DependencyList = [],
  type = 'text/javascript',
  target = document.head
) => {
  useEffect(() => {
    if (document.head.querySelector(`#${id}`) !== null) {
      return () => {};
    }
    const script = document.createElement('script');
    script.type = type;
    script.id = id;
    script.appendChild(document.createTextNode(content));
    target.appendChild(script);
    return () => {
      target.removeChild(script);
    };
  }, dependents); // eslint-disable-line react-hooks/exhaustive-deps
};
